import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-310">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-311">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-312">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight text-[#F5ECD7]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-313">
            🏆 EL CÓDIGO DE LA HIJA LIBRE
          </h2>
          <p className="text-[#C9A96E] text-xl md:text-2xl font-bold mb-4" data-id="element-314">
            6 Tomos + 6 Bonos — Método Sistémico Completo
          </p>
          <p className="text-[#FAF3E8] text-lg md:text-xl font-medium" data-id="element-315">
            360+ páginas — Todo el camino resuelto.
          </p>
        </div>
      </div>
    </section>;
}